import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "main-block" }
const _hoisted_2 = {
  key: 0,
  class: "lot-navigation-preloader"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "main-lot-image-block" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "main-lot-image" }
const _hoisted_10 = {
  key: 0,
  class: "magnifier-zoom-image"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["data-magnifier-src"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["disabled"]

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
  import Swiper from "@/components/_partials/Swiper.vue";
  import VideoPlayerCustom from "@/components/_partials/VideoPlayerCustom.vue";
  import CardInfoBlock from "@/components/CardInfoBlock.vue";
  import Preloader from "@/components/_partials/Preloader.vue";
  import { LotFileTypes } from "@/enum";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { ILotPopupData } from "@/models";
  import { isObject } from "lodash";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LotDetailsPopup',
  props: {
    lotProp: {},
    allLots: {},
    currentLotIndex: {},
    onNavigateToLot: { type: Function }
  },
  emits: ["closeForm", "changeTitle", "setModalHeightAuto"],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;

  const auctionStore = useAuctionStore();
  const lot = computed(() => auctionStore.popupLot as ILotPopupData);
  const files = computed(() => {
    return isObject(lot.value?.files) ? Object.values(lot.value?.files) || [] : [];
  });

  const props = __props;

  const isNavigating = ref(false);
  const currentLotId = ref<number | null>(null);

  const hasPrevLot = computed(() => {
    return props.allLots && props.currentLotIndex !== undefined && props.currentLotIndex > 0;
  });

  const hasNextLot = computed(() => {
    return props.allLots && props.currentLotIndex !== undefined && props.currentLotIndex < props.allLots.length - 1;
  });

  const navigateToPrevLot = () => {
    if (hasPrevLot.value && !isNavigating.value && props.onNavigateToLot && props.allLots && props.currentLotIndex !== undefined) {
      isNavigating.value = true;
      const prevLot = props.allLots[props.currentLotIndex - 1];
      props.onNavigateToLot(prevLot, props.currentLotIndex - 1);
    }
  };

  const navigateToNextLot = () => {
    if (hasNextLot.value && !isNavigating.value && props.onNavigateToLot && props.allLots && props.currentLotIndex !== undefined) {
      isNavigating.value = true;
      const nextLot = props.allLots[props.currentLotIndex + 1];
      props.onNavigateToLot(nextLot, props.currentLotIndex + 1);
    }
  };

  // Watch for lotProp changes and update store
  watch(
    () => props.lotProp,
    (newLot) => {
      if (newLot) {
        auctionStore.$patch((state) => {
          state.popupLot = newLot;
        });
        // Hide preloader when lot data is updated
        if (isNavigating.value && newLot.id !== currentLotId.value) {
          currentLotId.value = newLot.id;
          isNavigating.value = false;
        }
      }
    },
    { immediate: true }
  );

  onMounted(() => {
    auctionStore.$patch((state) => {
      state.popupLot = props.lotProp;
    });
    currentLotId.value = props.lotProp?.id || null;
  });

  onUnmounted(() => {
    auctionStore.$patch((state) => {
      state.popupLot = null;
    });
  });

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isNavigating.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Preloader)
        ]))
      : _createCommentVNode("", true),
    (hasPrevLot.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "lot-nav-arrow lot-nav-arrow-left swiper-navigation-btn",
          onClick: navigateToPrevLot,
          disabled: isNavigating.value
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (files.value?.length > 1)
        ? (_openBlock(), _createBlock(Swiper, {
            key: 0,
            class: "images-swiper-navigation",
            direction: "vertical",
            "slides-per-view": 'auto',
            navigation: true,
            type: "lotGallery"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  class: "navigation-image",
                  key: index
                }, {
                  default: _withCtx(() => [
                    (file.type === _unref(LotFileTypes).IMAGE)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: file.src,
                          alt: "lot"
                        }, null, 8, _hoisted_5))
                      : (file.type === _unref(LotFileTypes).PDF)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _unref(auctionStore).filePlaceholders.pdf_min,
                            class: "mini-video-placeholder",
                            alt: "lot"
                          }, null, 8, _hoisted_6))
                        : (file.type === _unref(LotFileTypes).VIDEO)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 2,
                              src: _unref(auctionStore).filePlaceholders.video,
                              class: "mini-video-placeholder",
                              alt: "lot"
                            }, null, 8, _hoisted_7))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 3,
                              src: _unref(auctionStore).filePlaceholders.no_image,
                              alt: "lot"
                            }, null, 8, _hoisted_8))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(Swiper, {
          "thumbs-swiper": ".images-swiper-navigation .swiper-wrapper",
          "slides-per-view": 1,
          navigation: false,
          "allow-touch-move": false,
          type: "lotGalleryMain"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                class: "swiper-slide",
                key: index
              }, {
                default: _withCtx(() => [
                  (file.type === _unref(LotFileTypes).IMAGE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("img", {
                          class: "magnifier-image",
                          src: file.src,
                          alt: "lot"
                        }, null, 8, _hoisted_11),
                        _createElementVNode("div", {
                          class: "magnifier-zone",
                          "data-magnifier-src": file.src
                        }, null, 8, _hoisted_12)
                      ]))
                    : (file.type === _unref(LotFileTypes).PDF)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: file.src,
                          class: "magnifier-zoom-image",
                          target: "_blank"
                        }, [
                          _createElementVNode("img", {
                            src: _unref(auctionStore).filePlaceholders.pdf,
                            alt: "lot",
                            class: "pdf-placeholder"
                          }, null, 8, _hoisted_14)
                        ], 8, _hoisted_13))
                      : (file.type === _unref(LotFileTypes).VIDEO)
                        ? (_openBlock(), _createBlock(VideoPlayerCustom, {
                            key: 2,
                            class: "custom-video-player magnifier-zoom-image",
                            "video-src": file.src,
                            title: "lot"
                          }, null, 8, ["video-src"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 3,
                            class: "magnifier-image",
                            src: _unref(auctionStore).filePlaceholders.no_image,
                            alt: "lot"
                          }, null, 8, _hoisted_15))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    (lot.value?.id)
      ? (_openBlock(), _createBlock(CardInfoBlock, {
          key: lot.value.id,
          onCloseForm: _cache[0] || (_cache[0] = ($event: any) => (emit('closeForm')))
        }))
      : _createCommentVNode("", true),
    (hasNextLot.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          class: "lot-nav-arrow lot-nav-arrow-right swiper-navigation-btn",
          onClick: navigateToNextLot,
          disabled: isNavigating.value
        }, null, 8, _hoisted_16))
      : _createCommentVNode("", true)
  ]))
}
}

})